import {
  GET_STARTED,
  GET_STARTED_CAROUSEL,
  SOLAR_WITHOUT_A_ROOF,
  SOLAR_WITHOUT_ROOF_CAROUSEL,
  HOW_IT_WORKS,
  HOW_IT_WORKS_CAROUSEL,
  READY_TO_SUBSCRIBE,
  READY_TO_SUBSCRIBE_CAROUSEL,
} from '~/components/image';
import { SolarScreenMap } from '~/machines/solar-funnel/screen-map';
import { ScreenMapCopy } from '~/machines/utils/types';
import { CardCopy } from '~/screens/micro-learning/card';

export const copy: ScreenMapCopy<SolarScreenMap> = {
  user: {
    'microLearning.getStarted': (): Partial<CardCopy> => ({
      header: 'Good news! Community Solar is available to you ',
      copyStrings: [
        'Here’s everything you need to know about Community Solar at Arcadia. It takes 2 minutes to learn how it works and get started.',
      ],
      imageType: GET_STARTED,
      carouselIndex: GET_STARTED_CAROUSEL,
    }),
    'microLearning.solarWithoutARoof': (): Partial<CardCopy> => ({
      header: 'Solar without a roof',
      copyStrings: [
        'Arcadia will connect you with a solar farm, so you don’t need to install solar panels.',
        "Anyone can join a community solar farm. Whether you're a renter or a homeowner.",
        'Solar farms produce carbon-free energy that goes to the grid. Your utility company continues to deliver energy to your home the same way.',
      ],
      imageType: SOLAR_WITHOUT_A_ROOF,
      carouselIndex: SOLAR_WITHOUT_ROOF_CAROUSEL,
    }),
    'microLearning.howItWorks': (): Partial<CardCopy> => ({
      header: 'How it works',
      copyStrings: [
        'You sign up with Arcadia and sync your utility account using our secure platform.',
        'Based on your energy usage, you are assigned to a portion of the solar farm.',
        'Once the solar farm starts producing energy, you’ll see savings that result in a lower annual power bill.',
      ],
      imageType: HOW_IT_WORKS,
      carouselIndex: HOW_IT_WORKS_CAROUSEL,
    }),
    'microLearning.readyToSubscribe': (): Partial<CardCopy> => ({
      header: 'Ready to subscribe to community solar?',
      copyStrings: [
        'It’s easy to direct part of your power bill towards clean, carbon-free electricity.',
      ],
      imageType: READY_TO_SUBSCRIBE,
      carouselIndex: READY_TO_SUBSCRIBE_CAROUSEL,
    }),
  },
  enrollment: {
    utilityConnect: () => {
      return {
        descriptionTwo: '',
      };
    },
  },
};
